import { CARD_VARIANT, ICard } from "@shared/components/card/types";
import { FC } from "react";
import { handleCourseUrl } from "@shared/utils/handleCourseUrl";
import ListCard from "./list-card";
import HalfListCard from "./half-list-card";
import CheckBoxCard from "./checkbox-card";
import CheckboxStartLearningCard from "./checkbox-start-learning";
import GridCard from "./grid-card";
import { useRouter } from "next/router";

const Card: FC<ICard> = (props) => {
  const { query } = useRouter();
  const { shp } = query;

  const href = handleCourseUrl(props.type, props.slug);
  const showCardFooter = shp !== "0";

  const cardContent = {
    [CARD_VARIANT.GRID]: (
      <GridCard
        {...props}
        href={href}
        isFestival={props.isFestival}
        showCardFooter={showCardFooter}
        showShoppingCart={true}
      />
    ),
    [CARD_VARIANT.LIST]: <ListCard {...props} href={href} />,
    [CARD_VARIANT.HALF_LIST]: <HalfListCard {...props} href={href} />,
    [CARD_VARIANT.CHECKBOX]: <CheckBoxCard {...props} href={href} />,
    [CARD_VARIANT.START_LEARNING]: (
      <CheckboxStartLearningCard {...props} href={href} />
    ),
  };
  return cardContent[props.variant || CARD_VARIANT.GRID];
};
export default Card;
